import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UnsavedChangesService } from '../services/unsaved-changes.service';

export const unsavedChangesGuard: CanDeactivateFn<unknown> = async () => {
  const unsavedChangesService = inject(UnsavedChangesService);
  return await unsavedChangesService.canDeactivateAsync();
};
